import { defineStore } from 'pinia';

export const useJobStore = defineStore('jobStore', {
  state: () => ({
    jobs: [],
    filter: {
      keyword: '',
      date: null,
    },
  }),
  actions: {
    async fetchJobs() {
      const rssUrl = 'https://yellowducktechnologiesinc.easyapply.co/rss';

      // Try multiple CORS proxies as fallbacks
      const corsProxies = [
        `https://api.allorigins.win/raw?url=${encodeURIComponent(rssUrl)}`,
        `https://corsproxy.io/?${encodeURIComponent(rssUrl)}`,
        `https://cors-anywhere.herokuapp.com/${rssUrl}`,
        rssUrl // Direct attempt as last resort
      ];

      for (let i = 0; i < corsProxies.length; i++) {
        try {
          console.log(`Attempting to fetch jobs from proxy ${i + 1}/${corsProxies.length}`);
          const response = await fetch(corsProxies[i], {
            headers: {
              'Accept': 'application/rss+xml, application/xml, text/xml'
            }
          });

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }

          const data = await response.text();
          const parser = new DOMParser();
          const xml = parser.parseFromString(data, 'application/xml');

          // Check for parsing errors
          const parseError = xml.querySelector('parsererror');
          if (parseError) {
            throw new Error('XML parsing failed');
          }

          const items = xml.querySelectorAll('item');
          if (items.length === 0) {
            throw new Error('No job items found in RSS feed');
          }

          const jobs = [];
          items.forEach(item => {
            jobs.push({
              title: item.querySelector('title').textContent,
              link: item.querySelector('link').textContent,
              description: item.querySelector('description').textContent,
              pubDate: new Date(item.querySelector('pubDate').textContent),
            });
          });

          this.jobs = jobs;
          console.log(`Successfully fetched ${jobs.length} jobs using proxy ${i + 1}`);
          return; // Success, exit the loop

        } catch (error) {
          console.warn(`Proxy ${i + 1} failed:`, error.message);
          if (i === corsProxies.length - 1) {
            // Last attempt failed, throw error
            console.error('All job fetch attempts failed:', error);
            throw error;
          }
        }
      }
    },
    setFilter(filter) {
      this.filter = { ...this.filter, ...filter };
    },
  },
  getters: {
    filteredJobs: (state) => {
      let jobs = state.jobs;

      if (state.filter.keyword) {
        const keyword = state.filter.keyword.toLowerCase();
        jobs = jobs.filter(job =>
          job.title.toLowerCase().includes(keyword) ||
          job.description.toLowerCase().includes(keyword)
        );
      }

      if (state.filter.date) {
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
        jobs = jobs.filter(job => job.pubDate >= sevenDaysAgo);
      }

      return jobs;
    },
  },
});